import Vue from 'vue';
import Component from 'vue-class-component';
import {DownloadHelper} from '../../../helpers/download';
import {Watch} from 'vue-property-decorator';
import {DataManager, Visualisation, Toolbar, Chart, FilterBar, CustomDynamicView} from 'wc-visualisation';
import {Table, Icon, Popover, pivotData, formatDate} from 'wc-lib';
import {format, addDays} from 'date-fns';
import { url } from 'inspector';
import { CsvDownloadMonths, CsvDownloadYears, NemRegions } from '../config';

@Component({
  template: require('./aggregated-price-and-demand-files.html'),
  name: 'aggregated-price-and-demand-files',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'vis-table': Table,
    'vis-chart': Chart,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover
  }
})
export class NemAggregatedPriceAndDemandFiles extends Vue {
  regions = NemRegions;
  currentSelectedRegion: string = 'NSW1';
  historicSelectedRegion: string = 'NSW1';
  years = CsvDownloadYears();
  months = CsvDownloadMonths;
  selectedYear = this.years[0];
  selectedMonth = this.months[0].value;
  currentMonth = this.months[addDays(new Date(), -1).getMonth()].value;

  get currentMonthLink() {
    return `../../data/nem/priceanddemand/PRICE_AND_DEMAND_${this.years[0]}${this.currentMonth}_${this.currentSelectedRegion}.csv`;
  }

  get historicMonthLink() {
    return `../../data/nem/priceanddemand/PRICE_AND_DEMAND_${this.selectedYear}${this.selectedMonth}_${this.historicSelectedRegion}.csv`;
  }
}


// WEBPACK FOOTER //
// src/views/electricity/nem/aggregated-price-and-demand-files.ts